import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.document.item');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;
declare const wiz: any;

@Component({
    selector: 'wiz-page-document-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.document.item/view.scss */
/* src/app/page.document.item/view.scss: no such file or directory */`],
})
export class PageDocumentItemComponent implements OnInit, OnDestroy {
    public documentId: string = '';
    public pdfName: string = '';
    public title: string = '';
    public currentPage: number = 1;
    public totalPages: number = 0;
    public pages: any[] = [];
    public loading: boolean = true;

    // 패널 너비 관리
    public leftPanelWidth: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();

        this.documentId = WizRoute.segment.id || '';
        if (!this.documentId) {
            this.service.href('/');
            return;
        }

        await this.loadDocument();
    }

    public ngOnDestroy() {
        // cleanup
    }

    private async loadDocument() {
        this.loading = true;
        await this.service.render();

        try {
            // 문서 메타데이터 로드
            const { code, data } = await wiz.call('info', { document_id: this.documentId });
            if (code !== 200) {
                this.service.href('/');
                return;
            }

            this.pdfName = data.pdf_name || '';
            this.title = data.title || data.pdf_name || '문서';
            this.totalPages = data.page_count || 0;

            // 페이지 목록 로드
            const pagesRes = await wiz.call('pages', { document_id: this.documentId });
            if (pagesRes.code === 200) {
                this.pages = pagesRes.data.pages || [];
            }

            this.currentPage = 1;
        } catch (e) {
            console.error('Document load error:', e);
            this.service.href('/');
            return;
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async goToPage(page: number) {
        if (page < 1 || page > this.totalPages) return;
        this.currentPage = page;
        await this.service.render();
    }

    public async onPageChange(page: number) {
        await this.goToPage(page);
    }

    public async onHeaderPageChange(page: number) {
        await this.goToPage(page);
    }

    public prevPage() {
        this.goToPage(this.currentPage - 1);
    }

    public nextPage() {
        this.goToPage(this.currentPage + 1);
    }

    public onDividerResize(delta: number) {
        // divider 리사이즈 처리 (FN-0020에서 채팅 패널 추가 시 활용)
    }
}

export default PageDocumentItemComponent;